// Shared Glassmorphism design tokens and styles
export const glass = {
  card: {
    background: 'rgba(255, 255, 255, 0.72)',
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    border: '1px solid rgba(255, 255, 255, 0.45)',
    borderRadius: 18,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  },
  cardHover: {
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
  },
  cardDark: {
    background: 'rgba(15, 23, 42, 0.75)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: 18,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  },
  input: {
    background: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    borderRadius: 10,
    padding: '10px 14px',
    fontSize: 13,
    color: '#1e293b',
    outline: 'none',
    transition: 'all 0.2s',
  },
  btn: {
    padding: '10px 22px',
    border: 'none',
    borderRadius: 10,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 13,
    transition: 'all 0.2s',
  },
  btnPrimary: {
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    color: '#fff',
    boxShadow: '0 4px 15px rgba(99, 102, 241, 0.35)',
  },
  btnSuccess: {
    background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
    color: '#fff',
    boxShadow: '0 4px 15px rgba(16, 185, 129, 0.35)',
  },
  btnDanger: {
    background: 'rgba(239, 68, 68, 0.1)',
    color: '#ef4444',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    boxShadow: 'none',
  },
  btnOutline: {
    background: 'rgba(255, 255, 255, 0.5)',
    color: '#6366f1',
    border: '1px solid rgba(99, 102, 241, 0.3)',
    boxShadow: 'none',
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 6px',
  },
  th: {
    textAlign: 'left',
    padding: '10px 14px',
    fontSize: 11,
    fontWeight: 700,
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
  },
  td: {
    padding: '12px 14px',
    fontSize: 13,
    color: '#334155',
    background: 'rgba(255, 255, 255, 0.4)',
    borderBottom: '1px solid rgba(241, 245, 249, 0.5)',
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: 24,
  },
  backLink: {
    color: '#6366f1',
    textDecoration: 'none',
    fontSize: 13,
    fontWeight: 500,
    display: 'inline-block',
    marginBottom: 12,
  },
  badge: (bg, color) => ({
    display: 'inline-block',
    padding: '3px 12px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    background: bg,
    color,
  }),
}
